import { assets } from '@/ui/assets'
import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import Image from 'next/image'

export function SuccessViewCheckmark({ isModal }: { isModal?: boolean }) {
  return (
    <div className="flex flex-col items-center">
      <Image src={assets.success} alt="success-img" className={cn(isModal ? 'w-16' : 'w-24')} />
      <Typography variant="h1" className={cn('text-center', isModal ? 'mt-4 text-4xl lg:text-4xl' : 'mt-8 ')}>
        Congrats, all done!
      </Typography>
    </div>
  )
}
